/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { HydrusColumnListSectionFragment } from "@cosmos/hygraph-schema";

import { BackgroundContainer, ResponsiveContainer, SectionContainer, SectionHeading } from "@components/elements";
import { VStack } from "@panda/jsx";

import { HydrusColumnList } from "./HydrusColumnList.organism";

export const HydrusColumnListSection = ({
	config,
	columns,
}: HydrusColumnListSectionFragment): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(columns?.length);
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer
			bgAnimation={config?.backgroundAnimation}
			bgImageAsset={config?.backgroundImage}
			bgFullHeight={config?.backgroundFullHeight}
			edsBackgroundColor={config?.edsBackgroundColor}
		>
			<ResponsiveContainer>
				<SectionContainer>
					<VStack alignItems="stretch" gap="eds.dimension.48" className="hydrus-column-list-section">
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? <HydrusColumnList columns={columns || []} /> : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
